import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {FindLoad, FindSuccess, ProfileInfo, userType} from "utils";
import {
    avatarActions,
    httpRequestsOnErrorsActions,
    httpRequestsOnSuccessActions,
    UploadServices,
} from "store";
import {LinearProgress} from "@mui/material";
import {ButtonMain} from "components";
import {Svg} from "assets";
import {FileUploader} from "react-drag-drop-files";

export const UploadAvatar = () => {
    const [error, setError] = useState("");
    const [showInputs, setShowInputs] = useState(false);
    const [uploadedFIle, setUploadedFile] = useState(null);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [isHoveredProfile, toggleHoveredProfile] = useState(false);
    const {myProfile} = ProfileInfo();
    const dispatch = useDispatch();

    const ACTION_TYPE =
        myProfile?.avatar?.url !== uploadedFIle?.file?.url && uploadedFIle?.file?.url
            ? "ADD_AVATAR"
            : myProfile?.avatar?.url
                ? "DELETE_AVATAR"
                : "";
    const successType = FindSuccess(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);


    useEffect(() => {
        if (successType?.length) {
            setShowInputs(false);
            setUploadedFile(null);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [successType]);

    const handleChancel = () => {
        setShowInputs(false);
        setError("");
        setUploadedFile(null);
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    };

    const handleUpload = async (e, k) => {
        error === "currentFile" && setError("");
        if (e) {
            let formData = new FormData();
            formData.append("files", e);
            try {
                setUploadLoader(true);
                const res = await UploadServices.UploadImage(formData);
                const pos = e.type.slice(e.type.search("/"));
                const fileType = pos.substring(1);

                const info = {
                    file: {
                        ...res?.data,
                        format: fileType,
                    },
                };
                setUploadedFile(info);
                setUploadLoader(false);
            } catch (e) {
                setUploadLoader(false);
            }
        }
    };
    const handleSaveAvatar = () => {
        if (
            myProfile?.avatar?.url !== uploadedFIle?.file?.url &&
            uploadedFIle?.file?.url
        ) {
            dispatch(avatarActions.addAvatar(myProfile.id, uploadedFIle, userType));
        } else {
            if (myProfile?.avatar?.url) {
                dispatch(avatarActions.deleteAvatar(myProfile.id, userType));
            }
        }
    };

    const handleRemove = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        setUploadedFile(null);
    };

    return (
        <div className="upload-avatar-wrapper">
            <div className="upload-avatar-svg_title-edit-btn">
                <div className="upload-avatar-svg_title">
                    <Svg.ProfileSvg/>
                    <p className="upload-avatar-title">Profile</p>
                </div>

                {!showInputs && (
                    <div
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setShowInputs(true);
                            setUploadedFile(myProfile?.avatar ? {file: myProfile?.avatar} : null);
                        }}
                        style={{
                            cursor: "pointer",
                        }}
                    >
                        <Svg.EditInfoSvg/>
                    </div>
                )}
            </div>
            {showInputs && (
                <div className="my-profile-drag-and-drop-wrapper">
                    <div
                        className="my-profile-drag-and-drop-block"
                        style={{background: isHoveredProfile ? "#E4F3FF" : ""}}
                        onDragEnter={() => toggleHoveredProfile(true)}
                        onDragLeave={() => toggleHoveredProfile(false)}
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                    >
                        {uploadLoader ? (
                            <div className="my-profile-drag-and-drop-liner-wrapper">
                                <LinearProgress style={{width: "100%", color: "#88C3E1"}}/>
                                <p className="my-profile-drag-and-drop-liner-text">
                                    Image Uploading{" "}
                                </p>
                            </div>
                        ) : (
                            <>
                                <div className="my-profile-drag-and-drop-content">
                                    <div
                                        className="my-profile-drag-and-drop-image"
                                        style={{
                                            padding: uploadedFIle?.file?.url ? 0 : "",
                                        }}
                                    >
                                        {uploadedFIle?.file?.url && !uploadLoader ? (
                                            <div className="my-profile-drag-and-drop-uploaded-img-wrapper">
                                                <div className="my-profile-drag-and-drop">
                                                    <img
                                                        src={uploadedFIle?.file?.url}
                                                        alt="icon"
                                                        style={{marginBottom: 0}}
                                                    />
                                                </div>

                                                <button
                                                    className="uploaded-close-btn"
                                                    onClick={handleRemove}
                                                >
                                                    <Svg.CloseButtonSvg/>
                                                </button>
                                            </div>
                                        ) : (
                                            <Svg.FileUploaderSvg/>
                                        )}
                                    </div>

                                    <div className="my-profile-drag-and-drop-choose-file">
                                        Drag and Drop or
                                        <label
                                            className="my-profile-drag-choose-file-text"
                                            htmlFor="newFile"
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Choose File
                                        </label>
                                    </div>

                                    <p className="my-profile-drag-and-drop_info">
                                        Supported file PDF, PNG, JPG. Max Size 10MB.
                                    </p>
                                    <p className="error-message">
                                        {error === "currentFile" ? "Please select file" : ""}
                                    </p>
                                </div>

                                <FileUploader
                                    classes={`my-profile-file-uploader ${isHoveredProfile ? "my-profile-file-uploader-hover" : ""}`}
                                    name="newFile"
                                    handleChange={handleUpload}
                                    onDraggingStateChange={(isDragging) => {
                                        toggleHoveredProfile(isDragging);
                                    }}
                                    dropMessageStyle={{display: "none"}}
                                    children={<div></div>}
                                />
                            </>
                        )}
                    </div>

                    <div className="flex" style={{gap: 10, marginTop: 16}}>
                        <ButtonMain
                            text="Cancel"
                            type="button"
                            onClick={handleChancel}
                            cancel
                            small
                        />

                        <ButtonMain
                            text="Change"
                            load={!!loader}
                            type={"button"}
                            className=""
                            onClick={handleSaveAvatar}
                            small
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
